import { useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { StatusEnum } from "../schema/coupon-schema";

export default function StatusFilter() {
  const [searchParams, setSearchParams] = useSearchParams();

  const status = searchParams.get("status") || "ALL";

  const form = useForm({
    defaultValues: {
      status,
    },
  });

  const handleStatusChange = (newStatus: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", "0");
    
    if (newStatus === "ALL") {
      newParams.delete("status");
    } else {
      newParams.set("status", newStatus);
    }
    
    setSearchParams(newParams);
    form.setValue("status", newStatus);
  };

  const handleReset = () => {
    const newParams = new URLSearchParams();
    newParams.set("page", "0");
    // Keep search if it exists
    const search = searchParams.get("search");
    if (search) newParams.set("search", search);
    setSearchParams(newParams);
    form.reset({ status: "ALL" });
  };

  const hasFilters = status && status !== "ALL";

  return (
    <Form {...form}>
      <div className="flex items-center gap-4">
        <FormField
          control={form.control}
          name="status"
          render={({ field }) => (
            <FormItem>
              <Select
                value={field.value}
                onValueChange={handleStatusChange}
              >
                <FormControl>
                  <SelectTrigger className="w-[180px]">
                    <SelectValue placeholder="Status" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="ALL">All Status</SelectItem>
                  <SelectItem value={StatusEnum.ACTIVE}>Active</SelectItem>
                  <SelectItem value={StatusEnum.INACTIVE}>Inactive</SelectItem>
                </SelectContent>
              </Select>
            </FormItem>
          )}
        />

        {hasFilters && (
          <Button
            type="button"
            variant="outline"
            onClick={handleReset}
          >
            <X className="h-4 w-4 mr-1" />
            Reset
          </Button>
        )}
      </div>
    </Form>
  );
}

